import { useListView } from "../../../../shared/providers/ListView/ListView"
import { FC, useState } from "react"
import { estados, roles } from "../../../../shared/datosFormularios/Informacion";
import { KTIcon } from "../../../../../_metronic/helpers";
import { useLayout } from "../../../../../_metronic/layout/core";
import clsx from "clsx";
import { Estado, Rol } from "../../../../shared/misc/BotonesAttributos";

export const UsuariosDropDownFilter: FC = () => {

    const { config } = useLayout()
    const daterangepickerButtonClass = config.app?.toolbar?.fixed?.desktop
        ? 'btn-light'
        : 'bg-body btn-color-gray-700 btn-active-color-primary'
        
    const { addFilter, removeFilters } = useListView();

    const [rol, setRol] = useState(0);
    const [estado, setEstado] = useState(0);

    const cambiarFiltros = () => {
        if (rol === 0) removeFilters("rolId");
        else addFilter("rolId", rol);

        if (estado === 0) removeFilters("estadoId");
        else addFilter("estadoId", estado);
    }

    const quitarFiltros = () => {
        setEstado(0);
        setRol(0);
    }

    return (
        <div className='menu menu-sub menu-sub-dropdown w-200px w-md-250px' data-kt-menu='true'>
            <div className='px-7 py-5'>
                <div className='fs-5 text-dark fw-bolder'>Filtros</div>
            </div>

            <div className='separator border-gray-200'></div>

            <div className='px-7 py-5'>
                <div className='mb-auto'>
                    <label className='form-label fw-bold'>Rol:</label>

                    <div className='fv-row mb-2 col p-1'>
                        <div className="form-check">
                            {
                                roles.map((_rol, i) => (
                                    <div className="mb-2" key={i}>
                                        <input
                                            onChange={(e) => setRol(parseInt(e.target.value))}
                                            checked={rol === _rol.valor}
                                            name="filter_rol"
                                            className="form-check-input"
                                            type="radio"
                                            value={_rol.valor}
                                        />
                                        <Rol rolId={_rol.valor as number} />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>

                <div className='mb-auto'>
                    <label className='form-label fw-bold'>Estado:</label>

                    <div className='fv-row mb-2 col p-1'>
                        <div className="form-check">
                            {
                                estados.map((_estado, i) => (
                                    <div className="mb-2" key={i}>
                                        <input
                                            onChange={(e) => setEstado(parseInt(e.target.value))}
                                            checked={estado === _estado.valor}
                                            name="filter_estado"
                                            className="form-check-input"
                                            type="radio"
                                            value={_estado.valor}
                                        />
                                        <Estado estadoId={_estado.valor as number} />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>

                <div className='d-flex justify-content-end'>
                    <button type='button' className={clsx('btn btn-sm btn-light btn-active-light-primary me-2', daterangepickerButtonClass)} onClick={quitarFiltros}>
                        <KTIcon iconName='arrow-circle-right' className='fs-1' />
                        Limpiar
                    </button>
                    <button
                        type='submit'
                        className='btn btn-sm btn-primary'
                        data-kt-menu-dismiss='true'
                        onClick={cambiarFiltros}
                    >
                        Aplicar
                    </button>
                </div>
            </div>
        </div>
    )
}